export default __webpack_public_path__ + "static/media/Egg dropp 2.b209bea2.JPG";